import { render, staticRenderFns } from "./CBUComponent.vue?vue&type=template&id=f2798ecc&"
import script from "./CBUComponent.vue?vue&type=script&lang=js&"
export * from "./CBUComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports